import { createContext, Dispatch, useContext } from "react";
import { TAppLayoutProps, AppLayoutType } from "./AppLayout";

const AppLayoutContext = createContext<{
  context: TAppLayoutProps;
  setContext: Dispatch<TAppLayoutProps>;
}>(undefined);

const useAppLayoutContext = () => {
  const { context, setContext } = useContext(AppLayoutContext);

  const setHideSidebar = (hide: boolean) => {
    const _context = { ...context };
    _context.hideSidebar = hide;
    setTimeout(() => {
      setContext(_context);
    });
  };

  const setShowHeader = (show: boolean) => {
    const _context = { ...context };
    _context.showHeader = show;
    setContext(_context);
  };

  const setHeaderText = (headerText: string) => {
    const _context = { ...context };
    _context.headerText = headerText;
    setContext(_context);
  };

  const setHideBackButton = (hide: boolean) => {
    const _context = { ...context };
    _context.hideBackButton = hide;
    setContext(_context);
  };

  const setLayoutType = (layoutType: AppLayoutType) => {
    const _context = { ...context };
    _context.layoutType = layoutType;
    setContext(_context);
  };

  const setBackButtonClick = (backButtonClick) => {
    const _context = { ...context };
    _context.backButtonClick = backButtonClick;
    setContext(_context);
  };

  if (!context) {
    throw new Error("useAppLayoutContext must be used inside AppLayoutContextProvider");
  }
  return {
    context,
    setBackButtonClick,
    setHeaderText,
    setHideSidebar,
    setHideBackButton,
    setLayoutType,
    setShowHeader,
    setContext,
  };
};

export { AppLayoutContext, useAppLayoutContext };
